/**
 * @generated SignedSource<<da00d4e9a16c1fe9d34092df56558ef6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TravelDocumentsListRefetchQuery$variables = {
  after?: string | null;
  first: number;
  search?: string | null;
};
export type TravelDocumentsListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentsList_data">;
};
export type TravelDocumentsListRefetchQuery = {
  response: TravelDocumentsListRefetchQuery$data;
  variables: TravelDocumentsListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelDocumentsListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "TravelDocumentsList_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TravelDocumentsListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TravelDocumentConnection",
        "kind": "LinkedField",
        "name": "travelDocuments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TravelDocumentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TravelDocument",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletable",
                        "storageKey": null
                      }
                    ],
                    "type": "Entity",
                    "abstractKey": "__isEntity"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63aa12e006d2b63a4177008f2fb48aa8",
    "id": null,
    "metadata": {},
    "name": "TravelDocumentsListRefetchQuery",
    "operationKind": "query",
    "text": "query TravelDocumentsListRefetchQuery(\n  $after: String\n  $first: Int!\n  $search: String\n) {\n  ...TravelDocumentsList_data_1Ozsmw\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n\nfragment TravelDocumentsListRow_document on TravelDocument {\n  id\n  name\n  ...EntityTableRow_entity\n}\n\nfragment TravelDocumentsList_data_1Ozsmw on Query {\n  travelDocuments(first: $first, after: $after, search: $search) {\n    edges {\n      node {\n        id\n        ...TravelDocumentsListRow_document\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b590e4b0ef969ec6483a621f43d9c04";

export default node;
